import React from 'react';

import { Tr } from '@chakra-ui/react';
import styled from '@emotion/styled';

const HeaderTr = styled(Tr)``;

const TableHeaderRow = ({ children, ...props }) => <HeaderTr {...props}>{children}</HeaderTr>;

export { TableHeaderRow };
